module.exports = __webpack_public_path__ + "46ba855fbf46204a718a2dd0975ab685.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/commons/green.png
// module id = 1340
// module chunks = 0